import { Component, Input } from '@angular/core';
import { TranslationService } from '../translations';
import { BasicPageLayoutOptions } from './BasicPageLayoutOptions';

@Component({
    selector: 'basic-page-side-navigation',
    template: `
        <div class="pageContent--aside">
            <div class="asideContent">
                <div class="pageContentInterrupt--noTitle">
                    <ng-content select="[page-side-nav-title]"></ng-content>
                </div>
                <div class="areaContainer">
                    <ng-content select="[page-side-nav]"></ng-content>
                </div>
            </div>
        </div>
    `,
    standalone: false
})
export class BasicPageSideNavigationComponent {
    @Input()
    options: BasicPageLayoutOptions = {};

    constructor(public TR: TranslationService) {}
}
